"use strict";

var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _reactIntl = require("react-intl");
require("../style/style.css");
var _utils = require("../utils");
var _draftJsCustomStyles = _interopRequireDefault(require("draft-js-custom-styles"));
var _draftJs = require("draft-js");
var _draftJsExportHtml = require("draft-js-export-html");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ProductDetailsModal = /*#__PURE__*/function (_react$default$PureCo) {
  function ProductDetailsModal() {
    _classCallCheck(this, ProductDetailsModal);
    return _callSuper(this, ProductDetailsModal, arguments);
  }
  _inherits(ProductDetailsModal, _react$default$PureCo);
  return _createClass(ProductDetailsModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        onClose = _this$props.onClose,
        productModalVisible = _this$props.productModalVisible,
        project = _this$props.project,
        product = _this$props.product,
        uriTransformer = _this$props.uriTransformer,
        cell = _this$props.cell,
        intl = _this$props.intl,
        defaultLanguage = _this$props.defaultLanguage;
      if (!product) return null;
      var name = (0, _utils.i18nData)(product, 'name', intl, defaultLanguage);
      var longDescription = (0, _utils.htmlTextData)((0, _utils.i18nData)(product, 'long_description', intl, defaultLanguage));
      var imageUri = (0, _utils.i18nData)(product, 'large_image_uri', intl, defaultLanguage);
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: !!productModalVisible ? 'flex' : 'none',
          background: cell.modal_backdrop_color,
          color: cell.modal_text_color,
          fontFamily: cell.font
        },
        className: 'tsku-modal-container',
        onClick: onClose
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'tsku-modal tsku-product-details-modal',
        style: {
          background: cell.modal_background_color
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'tsku-modal-close',
        style: {
          background: cell.modal_background_color
        }
      }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: 'times'
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "tsku-product-details-content"
      }, !!imageUri && /*#__PURE__*/_react.default.createElement("div", {
        className: "tsku-product-large-img"
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: "tsku-background-image",
        src: uriTransformer(imageUri),
        alt: "product-image"
      })), /*#__PURE__*/_react.default.createElement("h2", null, name), /*#__PURE__*/_react.default.createElement("div", {
        className: "tsku-product-long-description",
        dangerouslySetInnerHTML: {
          __html: longDescription
        }
      }))));
    }
  }]);
}(_react.default.PureComponent);
_defineProperty(ProductDetailsModal, "whyDidYouRender", true);
var _default = exports.default = (0, _reactIntl.injectIntl)(ProductDetailsModal);